module.exports = __webpack_public_path__ + "img/cdu-logo.e7f882ed.svg";